import * as CL from '@design-system/component-library';
import { RecordInput } from './RecordInput.js';
import { validateIPv6 } from './fieldValidation.js';

export const AAAAValueField = ({ index }: { index: number }) => (
  <CL.GridCol colsXS={4}>
    <RecordInput name="value" validate={validateIPv6} index={index} />
  </CL.GridCol>
);
